/**
 * Created by fers on 26.09.15.
 */

import { v4 as uuidv4 } from 'uuid';
import { declareEntity } from '../fw/MetaDataHelper.ts';
import { operationTypes } from './ChannelMappingDefType';
import * as Permission from '../util/Permission';

export default declareEntity({
    entity: "screenDefs",
    graphQL: "ScreenDef",
    dynamoPrefix: 'def',
    storageType: 'schema',
    name: "Screen Definition",
    writePermission: [
        Permission.PERM_EDIT_CHANNEL_DEF
    ],
    isPublic: true,
    parentRelation: "screenDefs",
    defaultTitle: (data) => {
        return data['name'];
    },
    fields: (types) => { return {
        id: {
            name: "Screen Definition ID",
            type: "id",
            defaultValue: () => {
                return uuidv4();
            },
            primaryKey: true,
            required: true,
            userEditable: false,
            isPublic: true,
        },
        name: {
            name: "Name",
            type: "string",
            translatable: true,
            defaultValue: "",
            isPublic: true,
        },
        description: {
            name: "Description",
            type: "text",
            defaultValue: "",
            translatable: true,
            isPublic: true,
        },
        operation: {
            name: "Operation",
            type: "enum",
            values: operationTypes,
            isPublic: true,
        },
        content: {
            name: "Content",
            type: "object",
            defaultValue: {},
            isPublic: true,
        },
        entityDef: {
            name: "Entity Definition",
            type: "relation",
            to: () => types['entityDefs'],
            defaultValue: (entityDef) => {
                return entityDef['id'];
            },
            required: true,
            parent: true,
            hiddenCreate: true,
        },
        useAsDefault: {
            name: "Use As Default (autocreate)",
            type: "boolean",
            defaultValue: false,
        },
        author: {
            name: "Author",
            type: "relation",
            to: () => types['users'],
            userEditable: false,
        },
        updatedAt: {
            name: "Updated At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        },
        createdAt: {
            name: "Created At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        }
    }; },
    relations: (types) => { return {
        views: {
            type: 'oneToMany',
            to: types['views'],
            hasPaging: false,
            export: true,
            defaultValue: () => {
                return {};
            },
            isPublic: true,
        },
        dataSources: {
            type: 'oneToMany',
            to: types['dataSources'],
            hasPaging: false,
            export: true,
            defaultValue: () => {
                return {};
            },
            isPublic: true,
        },
    }; }
});
